"use client";

interface MoneyProps {
  amount: number;
  currency?: string;
  className?: string;
}

const currencySymbols: Record<string, string> = {
  INR: "Rs.",
  USD: "$",
  EUR: "€",
  GBP: "£",
  SAR: "SAR",
};

export function Money({ amount, currency = "INR", className = "" }: MoneyProps) {
  const symbol = currencySymbols[currency] || currency;
  const formattedAmount = amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <span className={className}>
      {symbol} {formattedAmount}
    </span>
  );
}

export function formatMoney(amount: number, currency: string = "INR"): string {
  const symbol = currencySymbols[currency] || currency;
  const formattedAmount = amount.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formattedAmount}`;
}
